import { find, get } from 'lodash';

export const getCookie = (id: string) => {
  try {
    const safeCookie = get(document, ['cookie'], '');
    const result = find(safeCookie.split('; '), cookie => {
      const [name] = cookie.split('=');
      return name === id;
    });

    if (result) {
      return result.split('=')[1];
    }

    return undefined;
  } catch (e) {
    return undefined;
  }
};

export default getCookie;
